import { HEADER_HEIGHT } from "@/constants/components";
import { markMatchRequestOnboardingEligible } from "@/utils/matchRequestOnboardingExperiment";
import { Box, Button, useDisclosure, VStack } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { colors, GoiLogo, NextLink, useResponsive } from "goi_common";
import Menu from "../Menu";

export default function HomeLayout({ children }: { children: any }) {
  const { isOpen, onClose } = useDisclosure();
  const { isBiggerThanMd } = useResponsive();

  return (
    <>
      <GlobalContainer>
        {isBiggerThanMd && (
          <VStack
            width="260px"
            spacing="0px"
            alignItems="start"
            justifyContent="end"
            paddingBottom="100px"
          >
            <GoiLogo color={colors.black} size={80} />
            <Box height="24px" />
            <Box className="head_28_sb gray900">숨김없는 장례의 시작</Box>
            <Box height="12px" />
            <Box className="body_18_r gray700">
              장례식장부터 인력, 용품 비용까지
              <br /> 고이에서 맞춤 견적 확인하기
            </Box>
            <Box height="32px" />
            <NextLink
              href="/match/request/"
              event={{ newGtm: { path: "home", trigger_and_target: "layout_CTA-uv_mtch_rqst" } }}
            >
              <Button
                backgroundColor={colors.white}
                _hover={{
                  background: "none",
                }}
                borderRadius="6px"
                height="52px"
                padding="12px 20px"
                // 실험 #316: 홈 "장례 비용 알아보기" 클릭을 온보딩 A/B 자격으로 마킹.
                onClick={markMatchRequestOnboardingEligible}
              >
                <span className="body_18_m gray900">장례 비용 알아보기</span>
              </Button>
            </NextLink>
          </VStack>
        )}
        <GlobalWrapper
          style={{
            width: "var(--global-max-width)",
            overflowX: "hidden",
          }}
        >
          <VStack>{children}</VStack>
          <Menu isOpen={isOpen} onClose={onClose} />
        </GlobalWrapper>
      </GlobalContainer>
    </>
  );
}

// const BackgroundImage = styled.img`
//   position: absolute;
//   width: 100%;
//   height: calc(var(--vh) * 100);
//   opacity: 0.2;
//   background: ${colors.gray400};
// `;

export const GlobalContainer = styled.div`
  display: flex;
  height: calc(var(--vh) * 100 - ${HEADER_HEIGHT}px);
  justify-content: center;
  overflow: hidden;
  background: ${colors.gray100};
`;

export const GlobalWrapper = styled.div`
  position: relative;

  min-height: calc(var(--vh) * 100);
  background-color: var(--white);
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 0px !important;
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: -moz-scrollbars-none;
`;
